import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

var PresenceDot = function PresenceDot(_a) {
  var _a$status = _a.status,
    status = _a$status === undefined ? 'online' : _a$status,
    children = _a.children,
    hidden = _a.hidden,
    inverted = _a.inverted,
    themeProps = _a.themeProps,
    otherProps = __rest(_a, ["status", "children", "hidden", "inverted", "themeProps"]);
  return jsxs("span", Object.assign({
    className: "cogs-v10 cogs-presence-dot"
  }, otherProps, {
    children: [jsx("span", {
      className: "cogs-v10 cogs-presence-dot__element",
      children: children
    }), !hidden && jsx("div", {
      className: classNames.apply(undefined, ['cogs-v10', 'cogs-presence-dot__bubble', "cogs-presence-dot__" + status].concat(getThemeClassNames(inverted, themeProps))),
      role: "complementary"
    })]
  }));
};

export { PresenceDot };
